import { SelectionRange } from '@atlaskit/editor-prosemirror/state';
import { TableMap } from '../table-map';
export function getCellSelectionRanges($anchorCell, $headCell) {
  var table = $anchorCell.node(-1);
  var map = TableMap.get(table);
  var start = $anchorCell.start(-1);
  var rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
  var doc = $anchorCell.node(0);
  var cells = map.cellsInRect(rect).filter(function (p) {
    return p !== $headCell.pos - start;
  });
  // Make the head cell the first range, so that it counts as the
  // primary part of the selection
  cells.unshift($headCell.pos - start);
  return cells.map(function (pos) {
    var cell = table.nodeAt(pos);
    if (cell === null) {
      throw new Error("No cell at position ".concat(pos));
    }
    var from = pos + start + 1;
    return new SelectionRange(doc.resolve(from), doc.resolve(from + cell.content.size));
  });
}